import React, { useState } from "react";

import "./stylesGamePass.css";

import WeeklyChallenges from "./WeeklyChallenges/WeeklyChallenges";
import MonthlyChallenges from "./MonthlyChallenges/MonthlyChallenges";

const GamePass = ({ userData }) => {
  const [activeTab, setActiveTab] = useState("Weekly Challenges");

  return (
    <div className="user-manager-game-pass-container">
      <div className="user-manager-game-pass-header">
        <div className="user-manager-game-pass-header-tabs">
          <div
            className={`user-manager-game-pass-header-tab ${
              activeTab === "Weekly Challenges"
                ? "user-manager-game-pass-header-tab-selected"
                : ""
            }`}
            onClick={() => setActiveTab("Weekly Challenges")}
          >
            Weekly Challenges
          </div>
          <div
            className={`user-manager-game-pass-header-tab ${
              activeTab === "Monthly Challenges"
                ? "user-manager-game-pass-header-tab-selected"
                : ""
            }`}
            onClick={() => setActiveTab("Monthly Challenges")}
          >
            Monthly Challenges
          </div>
        </div>
      </div>
      <div className="user-manager-game-pass-body">
        {activeTab === "Weekly Challenges" && <WeeklyChallenges userData={userData} />}
        {activeTab === "Monthly Challenges" && <MonthlyChallenges userData={userData} />}
      </div>
    </div>
  );
};

export default GamePass;
